<template>
  <component :is="productTemplate" v-bind="props"></component>
</template>

<script>
import Base from '@/components/templates/products/base'

export default {
  name: 'ProductDetailPage',
  data () {
    return {
      productTemplate: null,
      props: {},
      product: {},
      ready: false
    }
  },
  mounted () {
    this.$router.push(`/${this.$route.params.sku}`)
    // const sku = this.$route.params.sku
    // this.fetch(sku).then(() => {
    //   this.$utils.fbTrack('VIEWED_CONTENT', this.product.price, {
    //     CONTENT_TYPE: 'product',
    //     CONTENT_ID: this.product.sku,
    //     CURRENCY: 'THB'
    //   })
    // })
  },
  methods: {
    fetch (sku) {
      return this.$http.get(`products/${sku}`)
        .then(resp => {
          this.product = resp.body
          this.ready = true

          if (this.product.type === this.$const.PRODUCT_TYPES.CATALOG && (!this.product.status || this.product.status === this.$const.PRODUCT_STATUSES.UNAVAILABLE)) {
            this.$router.push('/')
            return
          }

          // load template if specify
          if (this.product.template) {
            try {
              const template = require(`@/components/templates/products/${this.product.template}`)
              this.productTemplate = template
            } catch (err) {
              console.log(err)
              this.productTemplate = Base
            }
          } else {
            this.productTemplate = Base
          }
          this.props = {
            product: this.product
          }
        })
        .catch(err => {
          console.log(err)
          if (err.status === 404) {
            this.$modal.show({
              title: 'ผิดพลาด',
              text: 'ไม่พบรายการที่คุณต้องการ',
              okButtonText: 'กลับไปหน้าแรก',
              ok: () => {
                this.$router.push('/')
              }
            })
          } else {
            this.$utils.showCommonError()
          }
        })
    }
  },
  watch: {
    '$route': function (route) {
      this.fetch(route.params.sku)
    }
  }
}
</script>



// WEBPACK FOOTER //
// ProductDetailPage.vue?32404614